import { combineReducers } from "redux";
import orders from "./orders";
import bulk from "./bulk";
import signin from "./signin";
import upload from "./upload";
import users from "./users";
import validate from "./validate";
import clients from "./clients";
import tracking from "./tracking";
import ceps from "./ceps";

const reducers = combineReducers({
  signin,
  orders,
  bulk,
  users,
  validate,
  upload,
  clients,
  tracking,
  ceps
});

export default reducers